export const COLOR_OPTIONS = [
  { name: "Rojo", hex: "#DC2626" },
  { name: "Rosa", hex: "#EC4899" },
  { name: "Naranja", hex: "#F97316" },
  { name: "Amarillo", hex: "#FACC15" },
  { name: "Verde", hex: "#16A34A" },
  { name: "Turquesa", hex: "#14B8A6" },
  { name: "Azul", hex: "#2563EB" },
  { name: "Morado", hex: "#7C3AED" },
  { name: "Negro", hex: "#111827" },
  { name: "Gris", hex: "#9CA3AF" },
  { name: "Blanco", hex: "#FFFFFF" },
  { name: "Beige", hex: "#E7DCC8" },
  { name: "Café", hex: "#8B5E3C" },
  { name: "Dorado", hex: "#C0A062" },
  { name: "Plateado", hex: "#C0C0C0" },
  { name: "Multicolor", hex: "gradient" },
];

export const COLOR_MAP = COLOR_OPTIONS.reduce((m, c) => {
  m[c.name] = c.hex;
  return m;
}, {});

export const swatchStyle = (name) => {
  const hex = COLOR_MAP[name] || "#D1D5DB";
  if (name === "Multicolor" || hex === "gradient") {
    return { background: "conic-gradient(from 0deg, #DC2626, #FACC15, #16A34A, #2563EB, #7C3AED, #DC2626)" };
  }
  return { backgroundColor: hex };
};
